<template>
  <v-row>
    <v-col
      cols="12"
      class="mb-2"
    >
      <v-text-field
        v-model="searchVal"
        label="Search"
        hide-details
        outlined
        clearable
        append-icon="mdi-magnify"
        @click:append="getDataFromApi()"
        @keydown="checkKeypress"
      />
    </v-col>

    <v-col cols="12" style="position: relative;">
      
      <v-card>
        <v-data-table
          :headers="headers"
          :items="users"
          :options.sync="options"
          :server-items-length="totalUsers"
          :footer-props="tableFooterProps"
          :loading="loading"
          @click:row="userClicked"
        >
          

          <template v-slot:[`item.full_name`]="{ item }">
            <div class="py-2">{{ item.full_name }}<br><span class="grey--text">{{item.email}}</span></div>
          </template>
          <template v-slot:[`item.agent.full_name`]="{ item }">
            <div>
              <v-icon x-small class="mr-1">mdi-account-tie</v-icon>
              <span>{{ item.agent.full_name }}</span>  
            </div>
            <div>
              <v-icon x-small class="mr-1 grey--text text--lighten-1">mdi-handshake</v-icon>
              <span v-if="item.agent.partnership_id">{{ item.agent.partnership.name }}</span>
              <span v-else class="grey--text text--lighten-1">None</span>
            </div>
          </template>
          <template v-slot:[`item.created_at`]="{ item }">
            {{ $moment.unix(item.created_at).calendar() }}
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { TABLE_FOOTER_PROPS } from '@/global/consts';

export default {
  name: 'AdminClientsIndex',
  data: () => ({
    loading: true,
    searchVal: null,
    headers: [
      {
        text: 'ID',
        align: 'start',
        value: 'id',
        width: '80px'
      },
      {
        text: 'Name',
        align: 'start',
        value: 'full_name',
      },
      {
        text: 'Agent',
        align: 'start',
        value: 'agent.full_name'
      },
      {
        text: 'Created',
        align: 'start',
        value: 'created_at',
        width: '250px'
      }
    ],
    users: [],
    totalUsers: 0,
    options: {
      sortBy: ['created_at'],
      sortDesc: [true]
    },
    tableFooterProps: { ...TABLE_FOOTER_PROPS },
  }),
  mounted() {
    //this.getDataFromApi()
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi()
      },
      deep: true
    }
  },
  methods: {
    getDataFromApi() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      let qParams = []

      this.loading = true
      qParams.push('expand=agent,agent.partnership')
      qParams.push('f[type]=USER')
      if(sortBy[0]) qParams.push('sort=' + (sortDesc[0] ? '-' : '') + sortBy[0])
      qParams.push('per-page=' + itemsPerPage)
      qParams.push('page=' + page)
      if(this.searchVal) qParams.push('s=' + encodeURIComponent(this.searchVal))

      this.$http.get('users?' + qParams.join('&'))
        .then(response => {
          this.users = response.data.items
          this.totalUsers = response.data._meta.totalCount
        })
        .catch(err => {
          if(err.response.status == 401) return;
          this.$swal.fire('Error', 'There was an error loading users', 'error')
        })
        .finally(() => {
          this.loading = false
        })

    },
    userClicked(user) {
      this.$router.push({name: 'clients-view', params:{user_id: user.id}})
    },
    checkKeypress(e) {
      if(e.key == 'Enter') this.getDataFromApi()
    }
  }
}
</script>